import { render } from "./ReceitasTable.vue?vue&type=template&id=59327486"
import script from "./ReceitasTable.vue?vue&type=script&lang=js"
export * from "./ReceitasTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__